"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMakeRepeatPayIn = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useMakeRepeatPayIn = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, errorAction = _b.errorAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: function (args) {
            successAction === null || successAction === void 0 ? void 0 : successAction(args);
        },
        errorAction: function (args) {
            errorAction === null || errorAction === void 0 ? void 0 : errorAction(args);
        },
        path: keys_1.PAY_IN_REPEAT_MAKE,
    }), data = _c.data, mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        makeRepeatPayIn: mutate,
        isSubmitting: isSubmitting,
        error: error,
        data: data,
    }); }, [mutate, isSubmitting, error]);
};
exports.useMakeRepeatPayIn = useMakeRepeatPayIn;
